import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ProductStocksService } from 'src/app/services/product-stocks.service';

@Component({
  selector: 'app-product-stock-details',
  templateUrl: './product-stock-details.component.html',
  styleUrls: ['./product-stock-details.component.scss']
})
export class ProductStockDetailsComponent implements OnChanges {
  @Input() productId!: number;
  @Input() partnerId!: number;
  @Input() productVariantId?: number;
  @Input() productName?: string;
  @Input() variantName?: string;

  @Output() closed = new EventEmitter<void>();
  @Output() addStockClicked = new EventEmitter<void>();

  activeTab: 'lines' | 'movements' = 'lines';

  availableStock = 0;
  loadingAvailableStock = false;

  filters = {
    search: '',
    dateFrom: '',
    dateTo: '',
    status: '',
    type: '',
  };

  constructor(
    private stockService: ProductStocksService,
  ) {}

  ngOnChanges(): void {
    if (this.productId && this.partnerId) {
      this.loadAvailableStock();
    }
  }

  async loadAvailableStock(): Promise<void> {
    this.loadingAvailableStock = true;

    try {
      this.availableStock = await this.stockService.getAvailableStock(
        this.productId,
        this.partnerId,
        this.productVariantId
      );
    } catch (error) {
      this.availableStock = 0;
    } finally {
      this.loadingAvailableStock = false;
    }
  }

  setTab(tab: 'lines' | 'movements'): void {
    this.activeTab = tab;
  }

  resetFilters(): void {
    this.filters = {
      search: '',
      dateFrom: '',
      dateTo: '',
      status: '',
      type: '',
    };
  }

  onFilterChange(key: string, value: any): void {
    this.filters = {
      ...this.filters,
      [key]: value,
    };
  }
  close(): void {
    this.closed.emit();
  }
}